import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=53e23de2&"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=53e23de2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports